import { React, useCallback, useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getAlllearnerlabpractices, submitTodayPractice } from "../../services/AttendanceServices";
import { toast } from 'react-toastify';
import AttachmentModal from './AttachmentModal';
import { Box, Button } from '@mui/material';
import SubmitPracticeModal from '../todaysPractice/SubmitPracticeModal';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

export default function ModuleModal() {
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const fetchData = async () => {
    try {
      const response = await getAlllearnerlabpractices();
      setRows(response?.data?.data.data || []);
    } catch (error) {
      toast.error(error?.response?.data.message)
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmitPractice = useCallback((data) => {
    setSelectedPractice(data);
    setShowModal(true);
  }, []);

  const handleSubmit = async (practiceLink) => {
    if (selectedPractice) {
      try {
        const obj = { submission_link: practiceLink };
        const response = await submitTodayPractice(
          obj,
          selectedPractice.learnerDailyPractice.learnerDailyPracticeID,
          selectedPractice.daily_practice_id
        );
        toast.success(response.message || response.data.message);
      } catch (error) {
        toast.error(error?.message || error?.response?.message || error?.response?.data?.message);
      }
    }
  };
  return (
    <div style={{ width: '100%' }}>
      {rows.map((data) => (
        <Accordion key={data?.moduleID} sx={{ margin: "0 0 1rem 0" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`data-${data?.moduleID}-content`}
            id={`data-${data?.moduleID}-header`}
          >
            <Typography component="span" sx={{ fontSize: '1.2rem', width: "69%" }}>
              <strong> Day :</strong> {data?.daily_practice_name}
            </Typography>
            {
              data?.learnerDailyPractice?.submission_link &&
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "30%" }}>
                <CheckCircleRoundedIcon style={{ color: "green" }} />
              </Box>
            }
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1.1rem' }}>
              <strong> Module : </strong>{data?.Maker_Module?.module_Name} <strong>Topic :</strong> {data?.Topic?.topic_Name}
            </Typography>
            <AttachmentModal topics={data?.Topic} practice={data?.learnerDailyPractice} />
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "center", sm: "center", md: "flex-end" }, width: "100%", margin: "2rem 0 0" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={(event) => {
                  event.stopPropagation();
                  handleSubmitPractice(data)
                }}
              >
                SUBMIT PRACTICE
              </Button>
            </Box>
          </AccordionDetails>
          <SubmitPracticeModal selectedPractice={selectedPractice} open={showModal} handleClose={() => setShowModal(false)} handleSubmit={handleSubmit} />
        </Accordion>
      ))}
    </div>
  );
}
